<template>
  <v-container id="campuses" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="$i18n.t('Manage your Name, ID and Email Addresses.')"
          icon="mdi-account-circle"
          class="px-3 py-3 small-icon"
          color="primary"
        >
          <v-form id="form" ref="form" v-model="valid">
            <v-container>
              <v-col cols="12" md="10">
                <v-text-field :label="$i18n.t('Name')" v-model="profile.name" disabled></v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field :label="$i18n.t('Phone')" v-model="profile.phone" disabled></v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-text-field :label="$i18n.t('Email Id')" v-model="profile.email" disabled></v-text-field>
              </v-col>
              <v-col cols="12" md="10">
                <v-select :items="items" :label="$i18n.t('Gender')" v-model="value"></v-select>
              </v-col>
              <v-col cols="12" md="10">
                <z-language-select
                  :label="$i18n.t('Language')"
                  class="purple-input"
                  v-model="profile.lang"
                  clearable
                />
              </v-col>
            </v-container>

            <v-col cols="12" class="text-right">
              <v-btn
                color="success"
                class="mr-0"
                @click="save()"
                :loading="loading"
                :disabled="!valid"
              >
                <h3>{{ $i18n.t("Save") }}</h3>
              </v-btn>
            </v-col>
          </v-form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doPost, doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  url = "/api/profile/details";
  profile = {
    email: "",
  };
  sendCode = false;
  code = "";
  newEmail = "";
  value = "";
  valid = true;
  validationrules = {
    password: [(v) => !!v || this.$i18n.t("Password is required")],
    newEmail: [(v) => !!v || this.$i18n.t("New Email is required")],
  };
  items = ["Male", "Female", "Other"];

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.profile = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async save() {
    try {
      common.setLoading(true);
      const data1 = {
        email_verification_code: this.code,
        new_email: this.newEmail,
      };
      await doPost("/api/profile", data1);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
#bookingCheckbox {
  margin-left: 20px;
  margin-right: 20px;
  justify-content: space-between;
}
</style>
